import { useState, useEffect } from 'react'
import { Mode } from '.'
import { IBuildingDetails, IFloorDetails, IPortfolioRegion } from '@api'

/*
 * Maintains internal state of LocationSelect component
 */
export default function useSelection(
  mode: Mode,
  selectedId: string | null,
  regions: IPortfolioRegion[]
) {
  const [selected, setSelected] = useState<any>(null)

  useEffect(() => {
    if (!regions.length) return

    switch (mode) {
      case Mode.SINGLE_BUILDING:
        const building = findBuilding(selectedId, regions)
        setSelected(building)
        break

      case Mode.SINGLE_FLOOR:
        const floor = findFloor(selectedId, regions)
        setSelected(floor)
        break

      case Mode.SINGLE_BUILDING_FLOOR:
        let val: IFloorDetails | IBuildingDetails | null = findFloor(selectedId, regions)
        if (!val) val = findBuilding(selectedId, regions)
        setSelected(val)
        break

      default:
        break
    }
  }, [mode, selectedId, regions])

  return selected
}

function findBuilding(
  buildingId: string | null,
  regions: IPortfolioRegion[]
): IBuildingDetails | null {
  let building: IBuildingDetails | null = null

  if (!buildingId) return null

  regions.forEach(({ cities }) => {
    if (!building) {
      cities.forEach(({ buildings }) => {
        if (!building && buildings) {
          building = buildings.find(({ id }) => id === buildingId) || null
        }
      })
    }
  })

  return building
}

export function findFloor(
  floorId: string | null,
  regions: IPortfolioRegion[]
): IFloorDetails | null {
  let floor: IFloorDetails | null = null

  if (!floorId) {
    return null
  }

  regions.forEach(({ cities }) => {
    if (!floor) {
      cities.forEach(({ buildings }) => {
        if (!floor && buildings) {
          buildings.forEach(({ floors }) => {
            if (!floor && floors) {
              floor = floors.find(({ id }) => id === floorId) || null
            }
          })
        }
      })
    }
  })

  return floor
}
